"use client"

import {createContext, useContext, useState, useMemo, useRef, type ReactNode} from "react"

interface DocsSidebarContextValue {
    rightSidebarContent: ReactNode | null
    setRightSidebarContent: (content: ReactNode | null) => void
}

const DocsSidebarContext = createContext<DocsSidebarContextValue>({
    rightSidebarContent: null,
    setRightSidebarContent: () => {},
})

export function DocsSidebarProvider({children}: {children: ReactNode}) {
    const [rightSidebarContent, setRightSidebarContent] = useState<ReactNode | null>(null)
    const setterRef = useRef(setRightSidebarContent)
    setterRef.current = setRightSidebarContent

    // Stable setter that never changes identity
    const stableSetter = useMemo(() => (content: ReactNode | null) => {
        setterRef.current(content)
    }, [])

    const value = useMemo(() => ({
        rightSidebarContent,
        setRightSidebarContent: stableSetter,
    }), [rightSidebarContent, stableSetter])

    return (
        <DocsSidebarContext.Provider value={value}>
            {children}
        </DocsSidebarContext.Provider>
    )
}

export function useDocsSidebar() {
    return useContext(DocsSidebarContext)
}
